const icons = {};

icons.tag = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 9.5L4.5 15H19.5V9.5H4.5ZM4 8C3.44772 8 3 8.44772 3 9L3 15.5C3 16.0523 3.44772 16.5 4 16.5H20C20.5523 16.5 21 16.0523 21 15.5V9C21 8.44772 20.5523 8 20 8H4Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17 13H14V11.5H17V13Z" fill="#1679F9" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 13H7V11.5H13V13Z" fill="#1679F9" />
</svg>


export default icons;